import { Injectable } from '@angular/core';
import { Week } from '../../models/week';
import { APIService } from '../api.service';
import { Observable } from 'rxjs';
import { Converters } from '../../helpers/converters';
import { ApiTimecard } from '../../models/apiTimecard';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class TimeCardService {

    constructor( private api: APIService) {}

    public retrieveTimeCard(userName: string, timeCardNo: number, fromCurrent: boolean): Observable<ReturnObject<any>> {
        return this.api.getAPI(`timecard/${userName.toUpperCase()}/${timeCardNo}/${fromCurrent}`);
    }

    public deleteTimeCard(timecardId: number, userName: string): Observable<ReturnObject<string>> {
        return this.api.deleteByEnpointApi(`timecard/${timecardId}/${userName}`);
    }

    public saveTimeCard(userName: string, week: Week, status: string): Observable<ReturnObject<ApiTimecard>> {
        var apiTimeCard = Converters.fromWeek(userName, week, week.timeCard.timecardRows);
        apiTimeCard.status = status;
        return this.api.postAPI('timecard', apiTimeCard);
    }

    public unlockTimeCard(userName: string, timeCardNo: number): Observable<ReturnObject<string>> {
        return this.api.getAPI(`timecard/${userName.toUpperCase()}/${timeCardNo}`);
    }
}
